export class OfflineManager {
    private static _instance: OfflineManager;

    static get instance(): OfflineManager {
        if (!OfflineManager._instance) {
            OfflineManager._instance = new OfflineManager();
        }
        return OfflineManager._instance;
    }

    private constructor() {
        window.addEventListener('online', this._online);
        window.addEventListener('offline', this._offline);
    }

    get isOffline(): boolean {
        return !navigator.onLine;
    }

    private _online = () => {
        console.log('Online');
    };

    private _offline = () => {
        console.log('Offline');
    };
}
